
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Les Verts ont réalisé un bon historique: avec 17 sièges supplémentaires, c’est maintenant le quatrième parti le plus puissant du Conseil national. Ce n'est qu'en Suisse centrale que les progrès des Verts sont plus légers. `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;